<template>
  <SortsByV2
    v-if="isV2"
    :current-sort="currentSort"
    :link="link"
    :context="context"
    @update:sort-by="emit('update:sortBy', $event)"
  />
  <!-- The V1 toggle is a two-state relevance/newest switch, so it cannot express a per-context option
       set. Rendering nothing beats putting an unrelated "New discoveries" toggle on such a surface, and
       keeping the guard here means retiring DAT-3083 (deleting V1) removes it too. -->
  <SortsByV1
    v-else-if="!hasOwnOptionSet"
    :current-sort="currentSort"
    @update:sort-by="emit('update:sortBy', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isEnabled } from '@monolith/legacy/services/features';
import SortsByV1 from './sorts-by-v1.vue';
import SortsByV2 from './sorts-by-v2.vue';
import type { ProductSortBy } from '@bc/discovery/domain/catalog/types/product-search-parameters';
import { Context } from '@bc/discovery/domain/catalog/types/catalog';

const props = defineProps<{ currentSort: ProductSortBy; link?: boolean; context?: Context }>();
const emit = defineEmits<{ 'update:sortBy': [value: ProductSortBy | null] }>();

const isV2 = computed(() => isEnabled('DAT-3083'));
const hasOwnOptionSet = computed(() => props.context === Context.BRAND);
</script>
